import { ContentTypeFilter, ContentTypeFilterToContentTypeTag, ContentTypeTag } from '../models';

export const getContentTypeFilters = (articleType: ContentTypeFilter): ContentTypeTag[] => {
  if (articleType === ContentTypeFilter.ALL) {
    return [ContentTypeTag.Research, ContentTypeTag.Covenants, ContentTypeTag.News];
  }

  return [ContentTypeFilterToContentTypeTag[articleType]];
};
